module.exports = __webpack_public_path__ + "clipboard_add.5a3ebeda5671e85f6da739d73b202f59.svg";